/**
 * Theme Name: project-sscms v1.507.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - 9a4e5a170]
 * Version: 1.507.0-2025-07-10T15-30-54
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
/**
 * File video-background-slider.js.
 * Handles logic for the video background slider section.
 */
let isVbsInit = false;
function videoBackgroundSlider($) {
  if (isVbsInit) return;
  isVbsInit = true;
  const allVbs = document.querySelectorAll('[data-name="video_background_slider"]');

  for (let i = 0; i < allVbs.length; i++) {
    const vbs = allVbs[i];
    const multipleSlides = vbs.querySelectorAll(".video-background-slider__slide").length > 1;
    if (!multipleSlides) return;

    const slideContents = vbs.querySelectorAll(".video-background-slider__slide-content");
    const emailCapture = vbs.querySelector(".video-background-slider__cta .email-capture__input");
    const autoplay = vbs.querySelector(".video-background-slider__autoplay");
    const pause = vbs.querySelector(".video-background-slider__pause");
    const play = vbs.querySelector(".video-background-slider__play");
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    let reduceMotion = mediaQuery.matches;
    let pausedFlag = false;
    let lowPower = false;
    let isVisible = true;

    const jvbs = $(vbs);
    const sliderContainer = $(vbs.querySelector(".video-background-slider"));
    const slider = $(vbs.querySelector(".video-background-slider__slider"));
    const imagesOnly = slider.attr("data-images-only");
    const sliderFeature = slider.attr("data-feature");
    const sliderLocation = window.location.href;
    const sliderSection = $("body").attr("data-title");
    const sliderControls = jvbs.find(".progress-dots__controls");
    const playButton = jvbs.find('[data-action="play"]');
    const pauseButton = jvbs.find('[data-action="pause"]');
    const isDotSlider = sliderFeature == "progress-dots";
    let slidesViewed = new Array(jvbs.find(".video-background-slider__slide").length).fill(false);
    let motionEnabled = !reduceMotion && !imagesOnly && !lowPower;

    const options = {
      infinite: true,
      fade: true,
      dots: true,
      arrows: true,
      speed: 500,
      autoplaySpeed: 6500,
      slidesToShow: 1,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnDotsHover: false,
      prevArrow: jvbs.find(".video-background-slider__arrow--prev"),
      nextArrow: jvbs.find(".video-background-slider__arrow--next"),
      dotsClass: "progress-dots__pagination",
      appendDots: jvbs.find(".progress-dots__controls"), // Scope appendDots to each slider
    };

    let tryagainTSV = true;

    const trackSlideViewed = function (slideIndex) {
      if (!isVisible || !!slidesViewed[slideIndex]) return;

      if (typeof segmentTrackAndReturn !== "function") {
        if (tryagainTSV) {
          tryagainTSV = false;
          setTimeout(() => {
            trackSlideViewed(slideIndex);
          }, 200);
        }
        return;
      }

      const slideContent = $(slideContents[slideIndex]);
      const slideHeader = slideContent.find(".video-background-slider__header").text();
      const properties = {
        location: sliderLocation,
        section: sliderSection + " Slider",
        title: slideHeader,
        slide: "slide" + (slideIndex + 1),
      };

      slidesViewed[slideIndex] = segmentTrackAndReturn(
        "Slider Slide Viewed",
        properties
      );

      if (slidesViewed.every((val) => val)) observer.unobserve(slider[0]);
    };

    const ioOptions = {
      threshold: 0.75,
    };
    const observer = new IntersectionObserver((entries) => {
      isVisible = entries[0].isIntersecting;
      const slideIndex = jvbs.find(".video-background-slider__slide.slick-active").data("slick-index");
      trackSlideViewed(slideIndex);
    }, ioOptions);
    observer.observe(slider[0]);

    if (sliderFeature == "scroll-arrow") {
      options.dots = false;
      options.arrows = false;
      options.autoplaySpeed = 4000;
    } else if (isDotSlider) {
      options.arrows = false;
      options.autoplay = false;
    }

    // Function to update active slide content
    function updateActiveSlideContent(index) {
      // Remove active class from all slide contents
      slideContents.forEach(content => {
        content.classList.remove('active');
      });
      
      // Add active class to the current slide content
      if (slideContents[index]) {
        slideContents[index].classList.add('active');
      }
    }

    slider.on("init", function () {
      const jthis = $(this);
      const currentVideo = jthis.find(".video-background-slider__slide.slick-active video");
      const currentPoster = jthis.find(".video-background-slider__slide.slick-active picture");

      // Set the initial active slide content
      updateActiveSlideContent(0);

      currentVideo.one("play", function () {
        if (motionEnabled) {
          setVideo(currentVideo);
          hidePoster(currentPoster);
        }
      });

      if (isDotSlider) {
        sliderControls.attr("data-state", "playing");
        playButton.on("click", togglePlayPause);
        pauseButton.on("click", togglePlayPause);
      }

      slider.closest(".progress-dots--loading").removeClass("progress-dots--loading");

      animationEnded();
      setTimeout(() => trackSlideViewed(0), 250);
    });

    slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      // Update active slide content
      updateActiveSlideContent(nextSlide);
      
      const nextSlideEl = jvbs.find(".video-background-slider__slide[data-slick-index=" + nextSlide + "]");
      const nextVideo = nextSlideEl.find("video");
      const nextPoster = nextSlideEl.find("picture");

      if (isDotSlider) return;

      nextVideo.one("play", function () {
        hidePoster(nextPoster);
      });
      if (motionEnabled) {
        setVideo(nextVideo);
        nextVideo[0].pause();
        nextVideo[0].currentTime = 0;
      }
      if (!pausedFlag) playVidWithErrorHandler(nextVideo[0], nextPoster[0]);
    });

    slider.on("afterChange", function (event, slick, currentSlide) {
      pausedFlag ? pauseProgress() : showProgress();
      animationEnded();
      trackSlideViewed(currentSlide);
    });

    // Simply toggles a data attribute and the rest is handled by CSS animations.
    // the "animationEnded()" function is called once the slide timing animation
    // is complete and handles moving to the next slide. The animation is actually
    // paused and resumed in the CSS by targeting the state value.
    function togglePlayPause() {
      const isPaused = sliderControls.attr("data-state") === "paused";
      sliderControls.attr("data-state", !isPaused ? "paused" : "playing");
    }

    function setMotionEnabled() {
      motionEnabled = !reduceMotion && !imagesOnly && !lowPower;
    }

    function setVideo(el) {
      const videoDesktop = el.attr("data-video-desktop");
      const videoMobile = el.attr("data-video-mobile");
      const video = typeof isMobile == "function" && isMobile() ? videoMobile : videoDesktop;

      el.attr("src", video)
        .css("display", "block")
        .one("play", () => {
          showIcon("pause");
          pausedFlag = false;
        });
    }

    function hidePoster(el) {
      el.css("display", "none");
    }

    function pauseProgress() {
      const activeProgress = jvbs.find(".progress-dots__pagination .slick-active button");
      if (activeProgress) activeProgress.css("animation-play-state", "paused");
    }

    function showProgress() {
      const activeProgress = jvbs.find(".progress-dots__pagination .slick-active button");
      const pausedProgress = jvbs.find('.progress-dots__pagination .slick-active button[style="animation-play-state: paused;"]');
      if (activeProgress) activeProgress.css("animation-play-state", "running");
      if (pausedProgress) pausedProgress.css("animation-play-state", "running");
    }

    function showIcon(name) {
      if (!pause || !play) return;
      if (!name) {
        // Hide both icons when no name is provided
        play.style.display = "none";
        pause.style.display = "none";
      } else {
        play.style.display = name === "play" ? "block" : "none";
        pause.style.display = name === "pause" ? "block" : "none";
      }
    }

    function playVid() {
      pausedFlag = false;
      showIcon("pause");
      showProgress();
      slider.slick("slickPlay");
      
      // Also handle video playback if motion is enabled
      if (motionEnabled) {
        const activeVid = jvbs.find(".video-background-slider__slide.slick-active video")[0];
        const activePoster = jvbs.find(".video-background-slider__slide.slick-active picture")[0];
        playVidWithErrorHandler(activeVid, activePoster);
      }
    }

    function pauseVid() {
      pausedFlag = true;
      if (motionEnabled) {
        const activeVid = jvbs.find(".video-background-slider__slide.slick-active video")[0];
        activeVid.pause();
      }
      showIcon("play");
      pauseProgress();
      slider.slick("slickPause");
    }

    function hideVid(videoElem, posterElem) {
      videoElem.style.display = "none";
      posterElem.style.display = "block";
    }

    function resetProgress() {
      pauseProgress();
      const activeProgress = jvbs.find(".progress-dots__pagination .slick-active");
      activeProgress.removeClass("slick-active");

      setTimeout(() => {
        activeProgress.addClass("slick-active");
        showProgress();
      }, 50);
    }

    function resumeSlider() {
      pausedFlag = false;
      showProgress();
      slider.slick("slickPlay");
    }

    function playVidWithErrorHandler(videoElem, posterElem) {
      if (!motionEnabled) {
        if (!imagesOnly) hideVid(videoElem, posterElem);
        resumeSlider();
        return;
      } else {
        const vidObj = $(videoElem);
        if (vidObj.attr("src") == "") setVideo(vidObj);
      }

      let startPlayPromise = videoElem.play();

      if (startPlayPromise !== undefined) {
        startPlayPromise
          .then(() => {
            lowPower = false;
            setMotionEnabled();
            if (!pausedFlag && motionEnabled) resetProgress();
            showIcon("pause");
            resumeSlider();
          })
          .catch((error) => {
            if (error.name === "NotAllowedError") {
              lowPower = true;
              setMotionEnabled();
              addEcListeners();
              hideVid(videoElem, posterElem);
              showIcon("pause");
              resumeSlider();
            }
          });
      }
    }

    function animationEnded() {
      const currentAnimation = jvbs.find(".progress-dots__pagination .slick-active button");
      currentAnimation.one("animationend", function () {
        slider.slick("slickNext");
      });
    }

    function addEcListeners() {
      if (!motionEnabled && emailCapture) {
        emailCapture.addEventListener("focus", pauseVid);
        emailCapture.addEventListener("blur", playVid);
      }
    }

    slider.slick(options);
    addEcListeners();
    if (autoplay) {
      pause.addEventListener("click", pauseVid);
      play.addEventListener("click", playVid);
    }

    const updateReduceMotion = function (e) {
      if (isDotSlider) return;

      reduceMotion = e.matches;
      setMotionEnabled();
      const activeVid = jvbs.find(".video-background-slider__slide.slick-active video")[0];
      const activePoster = jvbs.find(".video-background-slider__slide.slick-active picture")[0];
      const activeObj = $(activeVid);

      if (!motionEnabled) {
        showIcon("pause");
        pausedFlag = false;
        showProgress();
      } else {
        setVideo(activeObj);
      }
      playVidWithErrorHandler(activeVid, activePoster);
    };

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", updateReduceMotion);
    } else {
      mediaQuery.addListener(updateReduceMotion);
    }

    updateReduceMotion(mediaQuery);

    const trackSliderButtonClicks = function (e) {
      const clickedEl = $(e.target);
      const btnLocation =
        clickedEl.closest(".video-background-slider__arrow--prev").length > 0
          ? "backward"
          : clickedEl.closest(".video-background-slider__arrow--next").length > 0
          ? "forward"
          : clickedEl.closest(".progress-dots__pagination").length > 0
          ? "slide" + parseInt(clickedEl.text())
          : false;

      if (!btnLocation) return;

      let eventName;

      switch (btnLocation) {
        case "backward":
        case "forward":
          eventName = "Slider Arrow Clicked";
          break;
        default:
          eventName = "Slider Bar Clicked";
      }

      const properties = {
        location: sliderLocation,
        btn_name: btnLocation,
      };

      segment("track", eventName, properties);

      // Analytics SDK firing
      fireAnalyticsEvent(Track.WebItemClicked, {
        unique_id: 'slider_bar_clicked',
        label: btnLocation,
        element_type: 'ELEMENT_TYPE_BUTTON',
      });
    };

    sliderContainer.on("click", trackSliderButtonClicks);
  }
}

// Add to variant callback list
if (window.explat) {
  registerExperimentCallback((key, variant) => {
    videoBackgroundSlider(jQuery);
  });
}

// No experiment
if (typeof jQuery !== "undefined") {
  jQuery(function ($) {
    videoBackgroundSlider($);
  });
}
